interface ConsentRegulatoryNoticeProps {
    className?: string
    /** "funnel" = borderless beige note of the optimized funnels */
    appearance?: "default" | "funnel"
}

function ConsentRegulatoryNoticeText() {
    return (
        <>
            {"Conformément à la réglementation en vigueur, nous avons besoin de votre accord explicite pour qu'un conseiller puisse vous contacter par téléphone. Cet accord, valable un an, "}
            <strong className="font-bold">est indispensable pour donner suite à votre demande de devis</strong>
            {" : sans lui, nous ne pourrons malheureusement pas la traiter."}
        </>
    )
}

// texte réglementaire (§3.2) partagé entre la page de gestion et les parcours de collecte du consentement
export default function ConsentRegulatoryNotice({ className = "", appearance = "default" }: ConsentRegulatoryNoticeProps) {
    const funnel = appearance === "funnel"
    return (
        <div
            className={`flex items-start ${
                funnel ? "gap-3 rounded-xl bg-[#FDF6E3] p-4" : "gap-4 rounded-2xl border border-[#f0e0be] bg-[#fdf6e7] p-4 md:p-5"
            } ${className}`}
        >
            <span
                aria-hidden="true"
                className={`flex size-6 shrink-0 items-center justify-center rounded-full ${funnel ? "bg-[#D9A21B]" : "bg-[#c8912a]"} text-[14px] font-bold text-white`}
            >
                i
            </span>
            <p className={`font-normal ${funnel ? "text-[13px] leading-[1.55] text-[#6E5613]" : "text-[12px] leading-[20px] text-[#865b07]"}`}>
                <ConsentRegulatoryNoticeText />
            </p>
        </div>
    )
}
